// accountEndpoints.js
import { ProdEnv } from "../config/env";
import { GetReportsLol } from "./accountService";


export const getUserByIdUrl = (userId) => {
    return `${ProdEnv.BASE_URL}/Users/${userId}`;
};

export const getClientByIdUrl = (clientId) => {
    return `${ProdEnv.BASE_URL}/Clients/${clientId}`;
};




// Or if you want to include it in the object
export const AccountService_ApiEndPoint = {

    //User Maintainence Api Endpoint
    GetUserList: ProdEnv.BASE_URL + "/Users",
    CreateUser: ProdEnv.BASE_URL + "/Users",
    GetUserType: ProdEnv.BASE_URL + "/client-types/user-types/dropdown",
    GetUserById: (userId) => ProdEnv.BASE_URL + "/Users/" + userId,
    GetManagedClientsUserModule: ProdEnv.BASE_URL + "/Clients/managed-dropdown",
    UpdateUserById: ProdEnv.BASE_URL + "/Users",
    DeleteUserById: (userId) => ProdEnv.BASE_URL + "/Users/" + userId + "/deactivate", // Base path for DELETE user

    //Client Maintainence 
    GetClientList: ProdEnv.BASE_URL + "/Clients",
    GetAllUsersInternalRoles: ProdEnv.BASE_URL + "/Clients/users/dropdown",
    GetAccountingType: ProdEnv.BASE_URL + "/Clients/accounting-types/dropdown",
    GetManagedClients: ProdEnv.BASE_URL + "/client-types/dropdown",
    CreateClients: ProdEnv.BASE_URL + "/Clients",
    GetStateType: ProdEnv.BASE_URL + "/Clients/state/dropdown",
    GetClientById: (clientId) => ProdEnv.BASE_URL + "/Clients/" + clientId,
    UpdateClientById: ProdEnv.BASE_URL + "/Clients",
    DeleteClientById: (clientId) => ProdEnv.BASE_URL + "/Clients/deleteclient/" + clientId,

    //Client Portal

    GetClientPortalList: ProdEnv.BASE_URL + "/ClientPortal/",
    GetParticularClientList: (clientId) => `${ProdEnv.BASE_URL}/ClientPortal/ClientDashboard/${clientId}`,
    GetTimezone: ProdEnv.BASE_URL + "/ClientPortal/Timezones/",
    CreateFavorite: ProdEnv.BASE_URL + "/ClientPortal/MarkFavourite",
    CreateContact: ProdEnv.BASE_URL + "/ClientPortal/CreateClientContact",
    UpdateContact: (clientId, contactId) =>
        ProdEnv.BASE_URL + `/ClientPortal/UpdateClientContact/${clientId}/${contactId}`,

    GetContact: (clientId) =>
        ProdEnv.BASE_URL + `/ClientPortal/GetClientContacts/${clientId}`,

    GetClientContactById: (clientId, contactId) => ProdEnv.BASE_URL + `/ClientPortal/GetClientContact/${clientId}/${contactId}`,



    //Authentication

    GetPermissions: ProdEnv.BASE_URL + "/permissions/all",

    Login: ProdEnv.BASE_URL + "/Auth/login",
    ForgotPassword: ProdEnv.BASE_URL + "/Auth/forgot-password",
    ResendOtp: ProdEnv.BASE_URL + "/Auth/resend-otp",
    forgotPasswordVerifyOtp: ProdEnv.BASE_URL + "/Auth/verify-forgot-otp",
    ResetPassword: ProdEnv.BASE_URL + "/Auth/reset-password",
    RefreshToken: ProdEnv.BASE_URL + "/Auth/refreshToken",

    //Tallies

    GetJobList: (clientId) => `${ProdEnv.BASE_URL}/ClientPortal/GetJobList?ClientId=${clientId}`,
    GetTalliesList: (jobId, clientId) =>
        `${ProdEnv.BASE_URL}/ClientPortal/GetTalliesList?jobId=${jobId}&ClientId=${clientId}`,

    //Jobs

    GetMetricsData: (clientId) => `${ProdEnv.BASE_URL}/client/jobs/${clientId}/summary`,
    GetJobsData: (clientId) => `${ProdEnv.BASE_URL}/client/jobs/${clientId}`,

    //JOB Module

    GetJobType: ProdEnv.BASE_URL + "/jobs/JobTypes",
    GetAccountingStatus: ProdEnv.BASE_URL + "/jobs/AccountingStatus",
    SearchJobList: ProdEnv.BASE_URL + "/jobs/list",
    GetJobDetailsById: (jobCode) => ProdEnv.BASE_URL + `/jobs/jobdetail/${jobCode}`,
    GetTechniques: ProdEnv.BASE_URL + "/jobs/Techniques",
    GetIssuesList: ProdEnv.BASE_URL + "/jobs/Issues",
    GetEstimateStatus: ProdEnv.BASE_URL + "/jobs/EstimateStatuses",
    GetJobDetailsbyUserId: ProdEnv.BASE_URL + "/Clients/by-user",
    CreateNewJob: ProdEnv.BASE_URL + "/Jobs",
    DeleteJobsById: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}`,
    UpdateJobsById: (jobId) => `${ProdEnv.BASE_URL}/jobs/${jobId}`,
    AccountingStatusUpdateDropdown: ProdEnv.BASE_URL + "/Jobs/accountingstatus",
    DeleteMailDetails: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}/MailDetails/mail-details`,
    ListNameDropdown: ProdEnv.BASE_URL + "/Lists/names",
    ListSegment: (listMasterID) => `${ProdEnv.BASE_URL}/Lists/segments/${listMasterID}`,
    CreateListSegmentValue: ProdEnv.BASE_URL + "/Lists/segment",
    CreateListName: ProdEnv.BASE_URL + "/Lists",
    CreateNewListSummary: (jobId) => `${ProdEnv.BASE_URL}/jobs/${jobId}/MailDetails/maildetails`,
    // UpdatedMailCodeList: (jobId, mailDetailId) =>
    //     ProdEnv.BASE_URL + `/jobs/${jobId}/MailDetails/mail-details/bulk-update/${mailDetailId}`,
    UpdatedMailCodeList: (jobId) =>
        `${ProdEnv.BASE_URL}/jobs/${jobId}/MailDetails/mail-details/bulk-update`,
    PostageMasterApi: ProdEnv.BASE_URL + "/Master/postages",

    //List Summary 

    GetListSummary: (jobCode) => `${ProdEnv.BASE_URL}/jobs/${jobCode}/list-summary`,

    //fILE uPLOAD
    GetDocumentTypes: ProdEnv.BASE_URL + "/document-types/files",
    GetJobFiles: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}/files`,
    UploadJobFile: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}/files`,
    DeleteJobFile: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}/files`,


    //Tallies Integrations

    UploadTallies: ProdEnv.BASE_URL + "/Tallies/upload",
    GetTalliesBatches: ProdEnv.BASE_URL + "/Tallies/batches",
    DeleteBatches: ProdEnv.BASE_URL + "/Tallies/batches/{batchNumber}/rows",
    GetBatchDetails: (tallyUploadId) => `${ProdEnv.BASE_URL}/Tallies/batches/${tallyUploadId}/details`,
    SaveBatchData: (batchNumber) => `${ProdEnv.BASE_URL}/Tallies/batches/${batchNumber}/save`,
    UpdateBatchDetails: (tallyUploadId) => `${ProdEnv.BASE_URL}/Tallies/batches/${tallyUploadId}/reassign`,

    //Cost Summary

    GetCostSummary: (jobId) => ProdEnv.BASE_URL + `/Cost/costsummary/${jobId}`,




    //Postage Cost

    GetPostageCost: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}/PostageCost`,
    UpdatePostageCost: (jobId) => ProdEnv.BASE_URL + `/jobs/${jobId}/PostageCost/bulk`,


    // Cost Summary

    // original url 
    // http://98.95.131.43/api/Cost/package/GetByJob/1

    // GetCostPackageByJobId: (jobId) => `${ProdEnv.BASE_URL}/Cost/package/GetByJob/${jobId}`
    GetCostPackageByJobId: ProdEnv.BASE_URL + "/Cost/package/GetByJob",
    CreateCostPackage: ProdEnv.BASE_URL + "/Cost/package",
    UpdateCostPackageByJobId: (jobId) => `${ProdEnv.BASE_URL}/Cost/package/${jobId}`,
    DeleteByCostCategoryId: ProdEnv.BASE_URL + "/Cost/packages",
    // GetCostPackageByJobId: ProdEnv.BASE_URL + "/Cost/package/GetByJob/1"

    GetBackendCostById: (jobId) => `${ProdEnv.BASE_URL}/Cost/package/GetByJob/${jobId}/3`,


    // List Costs

    GetListCosts: (jobId) => `${ProdEnv.BASE_URL}/jobs/${jobId}/list-costs`,
    UpdateListsCosts: (jobId) => `${ProdEnv.BASE_URL}/jobs/${jobId}/list-costs`,

    //List of List Integration

    GetTemplateListOfList: ProdEnv.BASE_URL + "/lol/template",
    UploadListOfList: ProdEnv.BASE_URL + "/lol/upload",
    GetListOfListDetails: ProdEnv.BASE_URL + "/lol/history",
    GetBatchDetailsListOfList: (jobId, versionNumber = null) => {
        const base = `${ProdEnv.BASE_URL}/lol/batch/${jobId}`;
        return versionNumber != null ? `${base}?versionNumber=${versionNumber}` : base;
    },
    GetLoLVersions: (jobId) => `${ProdEnv.BASE_URL}/lol/versions/${jobId}`,

    UploadClientProfilePicture: (clientId) =>
        `${ProdEnv.BASE_URL}/Clients/${clientId}/profile-picture`,

    GetClientProfilePicture: (clientId) =>
        `${ProdEnv.BASE_URL}/Clients/${clientId}/profile-picture`,
    DeleteCLientProfilePicture: (clientId) =>
        `${ProdEnv.BASE_URL}/Clients/${clientId}/profile-picture`,

    CreatePackageCostType: ProdEnv.BASE_URL + "/Cost/CostType",


    //Reports 

    GetJobDetailsReportData: (clientId) => `${ProdEnv.BASE_URL}/Reports/job-detail/${clientId}`,
    GetReportsFiltersData: ProdEnv.BASE_URL + "/Reports/filters/clients",
    GetFiltersJobByJobId: (clientIDs) => `${ProdEnv.BASE_URL}/Reports/filters/jobs?clientIDs=${clientIDs}`,
    GetFiltersJobReportJobDetails: (params = {}) => {
        const query = new URLSearchParams();
        if (params.clientIDs != null && params.clientIDs !== "") query.append("clientIDs", params.clientIDs);
        if (params.jobTypeIDs != null && params.jobTypeIDs !== "") query.append("jobTypeIDs", params.jobTypeIDs);
        if (params.mailStartDate) query.append("mailStartDate", params.mailStartDate);
        if (params.mailEndDate) query.append("mailEndDate", params.mailEndDate);
        if (params.jobIDs != null && params.jobIDs !== "") query.append("jobIDs", params.jobIDs);
        if (params.mailDetailIDs != null && params.mailDetailIDs !== "") query.append("mailDetailIDs", params.mailDetailIDs);
        if (params.listMasterIDs != null && params.listMasterIDs !== "") query.append("listMasterIDs", params.listMasterIDs);
        return `${ProdEnv.BASE_URL}/Reports/job-detail?${query.toString()}`;
    },
    GetFiltersJobReportJobDaily: (params = {}) => {
        const query = new URLSearchParams();
        if (params.clientIDs != null && params.clientIDs !== "") query.append("clientIDs", params.clientIDs);
        if (params.jobTypeIDs != null && params.jobTypeIDs !== "") query.append("jobTypeIDs", params.jobTypeIDs);
        if (params.mailStartDate) query.append("mailStartDate", params.mailStartDate);
        if (params.mailEndDate) query.append("mailEndDate", params.mailEndDate);
        if (params.jobIDs != null && params.jobIDs !== "") query.append("jobIDs", params.jobIDs);
        if (params.mailDetailIDs != null && params.mailDetailIDs !== "") query.append("mailDetailIDs", params.mailDetailIDs);
        if (params.listMasterIDs != null && params.listMasterIDs !== "") query.append("listMasterIDs", params.listMasterIDs);
        if (params.talliesStartDate) query.append("talliesStartDate", params.talliesStartDate);
        if (params.talliesEndDate) query.append("talliesEndDate", params.talliesEndDate);

        return `${ProdEnv.BASE_URL}/Reports/job-daily?${query.toString()}`;
    },
    GetReportsJobTypes: ProdEnv.BASE_URL + "/Reports/filters/job-types",
    GetListManagers: ProdEnv.BASE_URL + "/Master/listmanagers",
    GetListSelectManagerment: ProdEnv.BASE_URL + "/Master/segmentmasters",
    GetListMaintainance: ProdEnv.BASE_URL + "/Master/listmasters",
    CreateListMaintainance: ProdEnv.BASE_URL + "/Master/list",
    UpdateListMaintainance: (listId) => `${ProdEnv.BASE_URL}/Master/list`,
    DeleteListMaintainance: (listId) => `${ProdEnv.BASE_URL}/Master/list/${listId}`,
    GetClientResults: () => `${ProdEnv.BASE_URL}/Reports/client-results`,
    GetMonthlyMailVolume: () => `${ProdEnv.BASE_URL}/Reports/monthly-mail-volume`,
    GetCostReport: () => `${ProdEnv.BASE_URL}/Reports/cost-report`,
    GetReportsLol: ProdEnv.BASE_URL + "/Reports/lol",
    // GetReportsLol: (clientIDs) => `/Reports/lol?clientIDs=${clientIDs}`,
    GetReportsListAnalysisHeader: () => `${ProdEnv.BASE_URL}/Reports/list-analysis-header`,
    GetReportlistAnalysisDetail: () => `${ProdEnv.BASE_URL}/Reports/list-analysis-detail`,
    GetReportsCostTypes: ProdEnv.BASE_URL + "/Reports/filters/cost-types",

    GetRevenueReport: () => `${ProdEnv.BASE_URL}/Reports/revenue`,
    GetTrendAnalysisReport: () => `${ProdEnv.BASE_URL}/Reports/trend-analysis`,
};


